import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m12.277 7.965-3.938 3.937a.657.657 0 0 1-.93-.93l2.818-2.815h-8.04a.656.656 0 1 1 0-1.313h8.04L7.41 4.027a.657.657 0 0 1 .93-.93l3.937 3.937a.656.656 0 0 1-.001.93"
	})
});
const Memo = memo(SvgArrowRight);
export default Memo;
